import React, { useEffect } from "react";
import classnames from "classnames/bind";

import css from "./index.scss";
import headerImg from "./assets/BoardDetail_test2.jpeg";

const cx = classnames.bind(css);
const moduleName = "Direction";

const LAT = 37.2917858;
const LNG = 128.273205;

const Direction = () => {
  useEffect(() => {
    const initMap = () => {
      const naver = window.naver;
      if (!naver || !naver.maps) return;

      const center = new naver.maps.LatLng(LAT, LNG);
      const map = new naver.maps.Map("map", {
        center,
        zoom: 15,
        mapTypeControl: false,
      });

      const marker = new naver.maps.Marker({ position: center, map });

      const infowindow = new naver.maps.InfoWindow({
        content: [
          '<div style="padding:12px 16px;font-family:\'Noto Sans KR\',sans-serif;text-align:center;">',
          '<p style="font-size:0.9rem;font-weight:600;color:#2C2C2C;margin:0 0 4px;">스테이 무릉도원</p>',
          '<p style="font-size:0.78rem;color:#7A7468;margin:0;">강원도 영월군 무릉도원면 중방길 2</p>',
          "</div>",
        ].join(""),
        maxWidth: 220,
        backgroundColor: "#F5F0E8",
        borderColor: "#D4C5A9",
        borderWidth: 1,
        anchorSize: new naver.maps.Size(20, 20),
        anchorSkew: true,
        anchorColor: "#F5F0E8",
        pixelOffset: new naver.maps.Point(20, -20),
      });

      naver.maps.Event.addListener(marker, "click", function () {
        if (infowindow.getMap()) {
          infowindow.close();
        } else {
          infowindow.open(map, marker);
        }
      });
    };

    if (window.naver && window.naver.maps) {
      initMap();
    } else {
      const interval = setInterval(() => {
        if (window.naver && window.naver.maps) {
          clearInterval(interval);
          initMap();
        }
      }, 100);
      return () => clearInterval(interval);
    }
  }, []);

  return (
    <div className={cx(moduleName)}>
      {/* Hero */}
      <div className={cx(`${moduleName}-hero`)}>
        <img src={headerImg} alt="direction" className={cx(`${moduleName}-hero-img`)} />
        <div className={cx(`${moduleName}-hero-overlay`)} />
        <div className={cx(`${moduleName}-hero-content`)}>
          <p className={cx(`${moduleName}-hero-label`)}>Direction</p>
          <h2>오시는 길</h2>
          <p className={cx(`${moduleName}-hero-sub`)}>강원도 영월에서 기다리겠습니다</p>
        </div>
      </div>

      {/* Info strip */}
      <div className={cx(`${moduleName}-strip`)}>
        <div className={cx(`${moduleName}-strip-item`)}>
          <span className={cx(`${moduleName}-strip-label`)}>Address</span>
          <span className={cx(`${moduleName}-strip-value`)}>강원도 영월군 무릉도원면 중방길 2</span>
        </div>
        <div className={cx(`${moduleName}-strip-divider`)} />
        <div className={cx(`${moduleName}-strip-item`)}>
          <span className={cx(`${moduleName}-strip-label`)}>Tel</span>
          <a href="tel:01047386659" className={cx(`${moduleName}-strip-value`, `${moduleName}-strip-tel`)}>
            010 · 4738 · 6659
          </a>
        </div>
      </div>

      {/* Map */}
      <div className={cx(`${moduleName}-map-section`)}>
        <p className={cx(`${moduleName}-map-hint`)}>
          마커를 클릭하면 세부 정보를 확인할 수 있습니다.
        </p>
        <div id="map" className={cx(`${moduleName}-map`)} />
        <a
          href="https://map.naver.com/v5/search/강원도%20영월군%20무릉도원면%20중방길%202"
          className={cx(`${moduleName}-naver-btn`)}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>네이버 지도로 열기</span>
          <span className={cx(`${moduleName}-naver-arrow`)} />
        </a>
      </div>
    </div>
  );
};

export default Direction;



// WEBPACK FOOTER //
// ./src/App/pages/Home/pages/Direction/index.js